import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { getContainerStyles } from '../../../../utils/Utils';
import { AssetProps } from './Helpers';

import SliderContainer, { Slide } from './Slider';
import UniversalLinkContainer from './UniversalLink';
import Asset from './Asset';
import FullbleedWrapper from './FullbleedWrapper';

export default class DesignFeatures extends Component {
  static renderFeatureLink(links = [], copy) {
    const [link] = links;
    return link ? (
      <UniversalLinkContainer
        {...link}
        className={classNames('design-features__link', {
          'design-features__link-description': copy,
        })}
      >
        {copy && <span className="design-features__link-copy">{copy}</span>}
        <span
          className={classNames('design-features__link-title', {
            'design-features__link-title--heavy': copy,
          })}
        >
          {link.text}
        </span>
      </UniversalLinkContainer>
    ) : null;
  }

  renderFeatures() {
    const { points } = this.props;
    return points.map((point, i) => {
      const {
        icon,
        images: [image],
      } = point;

      return (
        <Slide key={i}>
          <div className="design-features__slide">
            <div className="design-features__image">
              <Asset
                asset={image}
              />
              {DesignFeatures.renderFeatureLink(point.links, point.copy)}
            </div>
            <div className="design-features__copy">
              <h2 className="design-features__copy-header">{point.header}</h2>
              <div className="design-features__icon-wrapper">
                <div className="design-features__icon">
                  <Asset
                    asset={icon}
                    imageProps={{
                      blurryPlaceholder: false,
                    }}
                  />
                </div>
                <p className="design-features__icon-title">{point.subHeader}</p>
              </div>
            </div>
          </div>
        </Slide>
      );
    });
  }

  render() {
    const {
      backgroundColor,
      textColor,
      theme,
      disableInfiniteSlider,
    } = this.props;

    return (
      <FullbleedWrapper
        backgroundColor={backgroundColor}
      >
        <section
          className="design-features"
          style={getContainerStyles(backgroundColor, textColor)}
        >
          <SliderContainer
            className="design-features__slider"
            theme={theme || 'light'}
            pagination={true}
            arrows={true}
            fade={true}
            slidesPerView={1}
            autoplay={true}
            speed={1000}
            pauseOnHover={true}
            disableInfinite={disableInfiniteSlider}
          >
            {this.renderFeatures()}
          </SliderContainer>
        </section>
      </FullbleedWrapper>
    );
  }
}

DesignFeatures.defaultProps = {
  backgroundColor: {
    hex: '#757E7E',
    css: 'rgb(117, 126, 126)',
    rgba: {
      r: 117,
      g: 126,
      b: 126,
      a: 1,
    },
  },
  textColor: {
    hex: '#F6EEE3',
    css: 'rgb(246, 238, 227)',
    rgba: {
      r: 246,
      g: 238,
      b: 227,
      a: 1,
    },
  },
};

DesignFeatures.propTypes = {
  points: PropTypes.arrayOf(PropTypes.shape({
    header: PropTypes.string,
    images: PropTypes.arrayOf(AssetProps).isRequired,
  })),
  backgroundColor: PropTypes.object,
  textColor: PropTypes.object,
};
